import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-qkl",
  "use": "icon-qkl-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-qkl\"><path d=\"M591.361 381.09v190.932H461.57v33.033h162.823V348.057H298.747v256.997h76.002v-33.033H331.78V381.09h259.581z m132.44 72.071h-76.002v33.033h42.969v190.932H431.143V486.194h129.79v-33.033H398.11v256.997H723.8V453.161zM512.033 917.775l-351.657-203.01V575.304h-36.212V735.61l387.87 223.943 170.816-98.612-18.106-31.355-152.711 88.189zM160.376 308.657l351.657-203.01 127.052 73.396 18.106-31.355L512.033 63.87l-387.87 223.943v214.713h36.212V308.657z m565.001-121.62l-18.106 31.355 156.376 90.266v406.064l-141.361 81.61 18.106 31.355 159.467-92.032V287.813L725.377 187.037z\" fill=\"#dbdbdb\" p-id=\"15482\" data-spm-anchor-id=\"a313x.7781069.0.i5\" class=\"\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/qkl.svg
// module id = VggY
// module chunks = 25